import {baseUrl} from './_baseUrl'
import {prepareHeaders} from './_utils'
import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react'

export const camerasApi = createApi({
  reducerPath: 'camerasApi',
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders
  }),

  endpoints: builder => ({
    getCameras: builder.mutation({
      query: options => `cameras?name=${options.name}&gid=${options.gid}`
    }),
    addCamera: builder.mutation({
      query: user => ({
        url: 'cameras',
        method: 'POST',
        body: user
      })
    }),
    updateCamera: builder.mutation({
      query: ({id, data}) => ({
        url: `cameras/${id}`,
        method: 'PUT',
        body: data
      })
    }),
    deleteCamera: builder.mutation({
      query: id => ({
        url: `cameras/${id}`,
        method: 'DELETE'
      })
    })
  })
})

export const {useGetCamerasMutation, useAddCameraMutation, useUpdateCameraMutation, useDeleteCameraMutation} =
  camerasApi
